import React, { Component } from 'react'
import { CloseCircleOutlined } from '@ant-design/icons'
import { Table, Button, Input, Alert } from 'hljd'
import { observer } from 'mobx-react'
import styles from '../style.module.less'
import { toJS } from 'mobx'
const columns = [{ title: '', dataIndex: 'value' }]

@observer
export default class extends Component {
  render() {
    const {
      chatType,
      template,
      onBlur,
      onFocus,
      changeField,
      edit,
      setContent
    } = this.props.store

    const _html = chatType.map(
      ({ key, name, value, visible, disabled, reason, status }, index) => (
        <div
          style={{
            marginBottom: +status === 2 ? 0 : 40,
            paddingLeft: 18,
            position: 'relative'
          }}
          key={index}
        >
          <span
            style={{
              display: 'inline-block',
              width: 100,
              fontSize: 14,
              color: '#666'
            }}
          >
            {name}
          </span>
          <div
            style={{
              width: 650,
              position: 'relative',
              marginRight: 20,
              display: 'inline-block'
            }}
          >
            <Input
              style={{ height: 46, paddingRight: 70 }}
              placeholder="请选择或输入接客问候"
              value={value}
              onFocus={onFocus(index)}
              onBlur={onBlur(index)}
              onChange={changeField(index, key)}
              ref={index}
            />
            <span
              style={{
                position: 'absolute',
                right: 20,
                top: 15,
                color: '#ccc',
                zIndex: 100
              }}
            >
              <span style={{ color: value.length > 95 ? '#f50' : '#ccc' }}>
                {value.length}
              </span>
              / 100
            </span>
          </div>
          <Button
            style={{ width: 120, height: 46 }}
            type="primary"
            disabled={disabled}
            onClick={edit(key)}
          >
            保存
          </Button>
          {+status === 2 && (
            <div className={styles.error} style={{ top: visible ? 46 : 375 }}>
              <CloseCircleOutlined
                style={{ color: '#f04134', marginRight: 10 }}
              />
              很遗憾，您所提交的（{name.substring(0, 2)}）接客问候语，因为“{
                reason
              }”的原因未通过审核，请重新编辑提交！
            </div>
          )}
          {!visible && (
            <div
              style={{ margin: '10px 0 0 80px', cursor: 'pointer', width: 650 }}
            >
              <Table
                rowKey={record => record.id}
                columns={columns}
                dataSource={toJS(template)}
                scroll={{ y: 325 }}
                pagination={false}
                showHeader={false}
                bordered
                onRow={(record, index) => {
                  return {
                    onClick: () => setContent(index, key, record)
                  }
                }}
              />
            </div>
          )}
        </div>
      )
    )
    return (
      <div className={styles.setting}>
        <div className={styles.warn}>
          <Alert
            message="在不同的场景可以设置不同的接客问候，审核通过后，用户浏览不同的场景时，都将收到您的接客问候。"
            banner
          />
        </div>
        {_html}
      </div>
    )
  }
}
